let domain = "/api";

const API = {
  FACTOR_BASIC: domain + "/factor/basic",
  FACTOR_NORMAL: domain + "/factor/normal",
  FACTOR_SUB: domain + "/factor/sub",
  FACTOR_LIST: domain + "/factor/list",
  PROJECT_LIST: domain + "/project_list ",
  PROJECT_BASE: domain + "/project",
  PROJECT_RESULT: domain + "/project/result",
  PROJECT_QRCODE: domain + "/project/qrcode",
  TABLE_BASE: domain + "/table",
  TABLE_COPY: domain + "/table/copy",
  TABLE_SCORED: domain + "/table/scored",
  TABLE_IMPORT: domain + "/table/import",
  SCORER: domain + "/scorer",
  SCORE: domain + "/score",

  COMMIT_EXCEL_SCORE: domain + "/commit_excel_score",
  COMMIT_SCORE: domain + "/score/commit",

  // 登录相关：账号密码登录已下线，统一走卓越认证中心（SSO）
  CHECK_LOGIN: domain + "/check_login",
  LOGOUT: domain + "/logout"
};

export { API, domain };
